import * as yup from 'yup';
import dataSetIcon from 'assets/images/icons/response-set-green.svg';

export const addCompanyFieldSchema = yup.object({
  fieldTitle: yup.string().required('Field title is required'),
  dbColumn: yup
    .string()
    .required('DB Column is required')
    .matches(
      /^[a-zA-Z_][a-zA-Z0-9_]*$/,
      'DB Column must start with a letter or underscore and contain only letters, numbers, or underscores',
    ),
  dataSource: yup.string().required('DataSource is required'),
  dataSourceColumn: yup.string().required('DataSource column is required'),
});

export const responseSetsTableHeader = [
  {
    name: 'name',
    displayName: 'table_header_response_set_name',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'choiceName',
  },
  {
    name: 'response_texts',
    displayName: 'table_header_response_texts',
    isSelected: true,
    type: 'text',
    associatedKey: 'choiceValue',
    populateFunc: 'populateResponseSetTexts',
  },
  {
    name: 'response_values',
    displayName: 'table_header_response_values',
    isSelected: true,
    type: 'text',
    associatedKey: 'choiceValue',
    populateFunc: 'populateResponseSetValues',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateResponseSetEditDeleteIcon',
    callbackFunc: 'editDeleteResponseSetClick',
  },
];

const opacityToHex = (opacityPercent) => {
  if (opacityPercent < 0 || opacityPercent > 100) return 'FF';
  const decimal = Math.round((opacityPercent / 100) * 255);
  const hex = decimal.toString(16).padStart(2, '0');
  return hex.toUpperCase();
};

export const changeOpacity = (hexCode, opacityPercent) => {
  const opacityHexCode = opacityToHex(opacityPercent);
  // hex code includes # in it
  if (hexCode.length === 7) return `${hexCode + opacityHexCode}`;
  else if (hexCode.length === 9) return `${hexCode.substring(0, 7) + opacityHexCode}`;
  else return hexCode;
};

export const dataSetsTabsList = [
  {
    id: 1,
    title: 'tabs_responses',
    value: 'responses',
    breadcrumbValue: { icon: dataSetIcon, items: ['sidebar_data_structure', 'tabs_responses'] },
  },
  {
    id: 2,
    title: 'tabs_company_field',
    value: 'company_field',
    breadcrumbValue: { icon: dataSetIcon, items: ['sidebar_data_structure', 'tabs_company_field'] },
  },
  {
    id: 3,
    title: 'tabs_forms_sets',
    value: 'forms_sets',
    breadcrumbValue: { icon: dataSetIcon, items: ['sidebar_data_structure', 'tabs_forms_sets'] },
  },
  {
    id: 4,
    title: 'tabs_questions_sets',
    value: 'questions_sets',
    breadcrumbValue: {
      icon: dataSetIcon,
      items: ['sidebar_data_structure', 'tabs_questions_sets'],
    },
  },
  {
    id: 5,
    title: 'tabs_topics_sets',
    value: 'topics_sets',
    breadcrumbValue: { icon: dataSetIcon, items: ['sidebar_data_structure', 'tabs_topics_sets'] },
  },
];

export const formsSetsHeaders = [
  {
    name: 'sr',
    isSelected: true,
    displayName: '#',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'indexed',
  },
  {
    name: 'title',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'title',
  },
  {
    name: 'sqlColumn',
    displayName: 'table_header_sql_column',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'sqlColumn',
  },
  {
    name: 'options',
    displayName: 'table_header_option',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'options',
    populateFunc: 'populateOptionsBadges',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateResponseSetEditDeleteIcon',
    callbackFunc: 'editDeleteFormsSetClick',
  },
];

export const questionsSetsHeaders = [
  {
    name: 'sr',
    isSelected: true,
    displayName: '#',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'indexed',
  },
  {
    name: 'title',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'title',
  },
  {
    name: 'sqlColumn',
    displayName: 'table_header_sql_column',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'sqlColumn',
  },
  {
    name: 'options',
    displayName: 'table_header_option',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'options',
    populateFunc: 'populateOptionsBadges',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateResponseSetEditDeleteIcon',
    callbackFunc: 'editDeleteQuestionsSetClick',
  },
];

export const topicsSetsHeaders = [
  {
    name: 'sr',
    isSelected: true,
    displayName: '#',
    isFilterAble: false,
    type: 'text',
    tableType: 'user',
    associatedKey: 'indexed',
  },
  {
    name: 'title',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'title',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    isFilterAble: false,
    populateFunc: 'populateResponseSetEditDeleteIcon',
    callbackFunc: 'editDeleteTopicSetClick',
  },
];

export const CompanyFieldHeaderList = [
  {
    name: 'fieldTitle',
    displayName: 'table_header_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'fieldTitle',
  },
  {
    name: 'dbColumn',
    displayName: 'table_header_sql_column',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'dbColumn',
  },
  {
    name: 'dataSourceName',
    displayName: 'table_header_datasource_file',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'dataSourceName',
  },
  {
    name: 'dataSourceColumnName',
    displayName: 'table_header_datasource_column',
    type: 'string',
    isRequired: false,
    isSelected: true,
    isFilterAble: true,
    associatedKey: 'dataSourceColumnName',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'description',
  },
  {
    name: 'createdAt',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdAt',
    populateFunc: 'populateDateTime',
  },
  {
    name: 'updatedAt',
    displayName: 'table_header_last_updated',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'updatedAt',
    populateFunc: 'populateDateTime',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: true,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitials',
  },
  {
    name: 'hidden',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    isFilterAble: false,
    associatedKey: 'isDeleted',
    populateFunc: 'populateCompanyFieldHiddenIcon',
  },
  {
    name: 'edit_delete',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateCompanyFieldEditIcon',
    callbackFunc: 'actionOnclick',
  },
];

export const transformDataSources = (rawData) => {
  const dataSourceMap = {};
  const columnMapByDataSourceId = {};
  const dataSourceOptions = [];
  const columnDisplayMap = {};

  rawData.forEach((ds) => {
    const dataSourceId = ds._id;
    const schemaName = ds.schemaName ?? '';
    const schema = ds.dataSourceSchema ?? [];
    if (schema.length) {
      dataSourceMap[dataSourceId] = schemaName;
      columnMapByDataSourceId[dataSourceId] = schema.map((col) => ({
        value: col.columnId,
        displayValue: col.columnName,
      }));
      dataSourceOptions.push({ value: dataSourceId, displayValue: schemaName });
      columnDisplayMap[dataSourceId] = Object.fromEntries(
        schema.map((col) => [col.columnId, col.columnName]),
      );
    }
  });
  return {
    dataSourceMap,
    columnMapByDataSourceId,
    dataSourceOptions,
    columnDisplayMap,
  };
};
